/** @jsx jsx */
import { jsx } from 'theme-ui';
import View from '../View/View';
import propTypes from 'prop-types';

const tags = {
  default: 'div',
};

export default function Label({ as, variant = 'default', children, ...rest }) {
  return (
    <View
      as={as || tags[variant] || tags.default}
      sx={{ variant: `label.${variant}` }}
      {...rest}
    >
      {children}
    </View>
  );
}

Label.propTypes = {
  /**
   * The style variant.
   */
  variant: propTypes.oneOf(['default', 'large', 'small']),
  /**
   * The tag to use.
   * */
  as: propTypes.elementType,
  /**
   * The label text or content.
   */
  children: propTypes.node,
};
